/**
 * Centralized localStorage keys to prevent conflicts and ensure consistency
 */
export const LOCAL_STORAGE_KEYS = {
    NAV_STATE: 'navState',
    HELP_PANEL_STATE: 'helpPanelState',
} as const;

export type LocalStorageKey =
    (typeof LOCAL_STORAGE_KEYS)[keyof typeof LOCAL_STORAGE_KEYS];
